import moment from "moment";
import { createContext, useContext, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { API, endpoints } from "../api";
import { ConfirmationNoBtn } from "../components";
import strings, { toastType } from "../utils/strings";
import { errorToString } from "../utils/utils";
import { useAuth } from "./Auth";

export const EnterEventContext = createContext({
  onEventSelect: (_event) => { },
  events: [],
  selectedEvent: null,
  editId: null,

  currency: "₹",
  lateFee: {
    firstDivisionSurcharge: 0,
    additionalDivisionSurcharge: 0,
  },
  isProUser: false,

  setSelectedEvent: (_data) => { },
  withdrawDivision: (_id) => { },

  enrollData: {},
  setEnrollData: (_data) => { },
  enrollEvent: () => { },
  agreeRef: null,

  termsError: {},
  setTermsError: (_val) => { },
  termsChecked: {},
  setTermChecked: (_val) => { },
  setConfirmation: (_val) => { },

  eventVideoFee: (_val) => { },

  isLateFeeAppliedOnEditEvent: false,
});

export const EnterEventProvider = (props) => {
  const [enrollData, setUpdatedEnrollData] = useState({});
  const [events, setEvents] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState();
  const {
    showToast,
    showGlobalLoader: setLoading,
    userCheck,
    user,
  } = useAuth();

  const isProUser =
    user?.user?.professional === "yes" ||
    user?.user?.pro_qualified === "yes";

    console.log("user => ", user, isProUser)

  /** get user data, if user do login on enter event page */
  useEffect(() => {
    if (user && !events?.length) {
      getData()
    }
  }, [user])

  const agreeRef = useRef(null);
  const [termsError, setTermsError] = useState(false);
  const [termsChecked, setTermChecked] = useState(false);

  const [editId, setEditId] = useState();
  const [isLateFeeAppliedOnEditEvent, setLateFeeApplied] = useState(false);

  const params = useParams();
  const location = useLocation();

  useEffect(() => {
    setSelectedEvent(null)
    setUpdatedEnrollData(null);
  }, [location?.pathname])

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const getAPIUrl = (url) => {
    return props?.enrolId ? `offlineregistration/${url}` : url
  }

  useEffect(() => {
    setLateFeeApplied(false)
    setEditId(params?.editEventId || props?.enrolId);
    if (params?.editEventId || props?.enrolId) {
      getData()
      setLoading(true)
      API.get({
        route: `${getAPIUrl(endpoints.EVENT_ENROL)}?enrolId=${params?.editEventId || props?.enrolId}${props?.userId ? `&userId=${props?.userId}` : ''}`,
      })
        .then((data) => {
          const enrolEditData = data?.result?.find(
            ({ id }) => id == params?.editEventId || props?.enrolId
          );

          enrollData.doWantDvd = (enrollData.doWantDvd || enrolEditData?.doWantDvd)
          updateEventWithType([{ ...enrolEditData?.events, actions: enrolEditData?.actions }]);

          if (!enrollData.division) {
            enrollData.division = [];
          }
          const isLateFeeApplied = enrolEditData?.enrolledDivisions?.find(({ lateFee }) => !!lateFee)
          if (isLateFeeApplied || enrolEditData?.lateFeesApply === 'true') {
            setLateFeeApplied(true)
          }
          enrolEditData?.enrolledDivisions?.map(
            ({ divisionId: eventDivisionId, lateFee, photoFee, entryFee, originalEntryFee }) => {
              const divisionIndex = enrolEditData?.events?.divisions?.findIndex(
                ({ id }) => id === eventDivisionId
              );

              if (divisionIndex >= 0) {
                const division =
                  enrolEditData?.events?.divisions[divisionIndex];

                enrolEditData.events.divisions[divisionIndex].selected = true;

                const isExist = enrollData?.division?.find(
                  ({ eventDivisionId: id }) => id === eventDivisionId
                );

                if (!isExist) {
                  const baseEntryFee = Number(originalEntryFee ?? (lateFee || entryFee) ?? 0);
                  const finalEntryFee = Number(entryFee ?? 0);
                  enrollData.division.push({
                    eventDivisionId,
                    divisionTypeId: division?.divisionTypeId,
                    baseEntryFee,
                    divisionDiscountAmount: Math.max(baseEntryFee - finalEntryFee, 0),
                    entryFee: Number(entryFee ?? 0),
                    lateFee: Number(lateFee ?? 0),
                    finalEntryFee,
                    photoFee,
                  });
                }
              }
            }
          );

          if (!enrollData?.additionalServiceId) {
            enrollData.additionalServiceId = [];
          }
          enrolEditData?.enrolledAdditionalServices?.map(
            ({ eventAdditionalServiceId: id, serviceFeeYes, serviceFeeNo }) => {
              const val = { id };

              if (serviceFeeYes) {
                val.serviceFeeYes = serviceFeeYes;
              } else if (serviceFeeNo) {
                val.serviceFeeNo = serviceFeeNo;
              }

              const isExist = enrollData?.additionalServiceId?.find(
                ({ id: mapId }) => mapId === id
              );

              if (!isExist) enrollData.additionalServiceId.push(val);
            }
          );


          setSelectedEvent({ ...enrolEditData?.events, actions: enrolEditData?.actions });
          enrollData.eventId = enrolEditData?.events?.id;
          setEnrollData(enrollData, enrolEditData?.events);
        })
        .catch((data) => {
          showToast({
            text: errorToString(data?.response),
            type: toastType.ERROR,
          });
        })
        .finally(() => setLoading(false));
    }
    else getData();
  }, [params?.editEventId]);

  const [currency, setCurrency] = useState("₹");
  const [lateFee, setLateFee] = useState({
    firstDivisionSurcharge: 0,
    additionalDivisionSurcharge: 0,
  });
  const navigate = useNavigate();

  const [confirmation, setConfirmation] = useState({
    title: strings.eventChange,
    subTitle: strings.eventChangeSubTitle,
    yesText: "Yes",
    noText: "No",
    open: false,
  });

  const eventVideoFee = (val, eventData) => {
    const dvdSelectOptions = { 1: "dvdFee", 2: "downloadFee" }; //0 will be No option so price will be 0
    return (val && (selectedEvent || eventData)?.[dvdSelectOptions[val]]) || 0;
  }

  const getActiveDiscountByType = (discountType, eventData = selectedEvent) => {
    const eventDiscounts = Array.isArray(eventData?.discounts)
      ? eventData?.discounts
      : [eventData?.discounts].filter(Boolean);

    return eventDiscounts?.find(({ discount_type, discountType: type, is_active, isActive }) => {
      const discountTypeValue = `${discount_type || type || ""}`.toLowerCase();
      const isActiveValue = is_active ?? isActive;

      return (
        discountTypeValue === `${discountType}`.toLowerCase() &&
        (isActiveValue === 1 || isActiveValue === "1" || isActiveValue === true)
      );
    });
  };

  const getDiscountAmount = (baseAmount, discountDetail) => {
    const amount = Number(baseAmount || 0);

    if (!discountDetail || !amount) {
      return 0;
    }

    const discountMethod = `${discountDetail?.discount_method || discountDetail?.discountMethod || ""}`.toLowerCase();
    const discountValue = Number(discountDetail?.discount_value ?? discountDetail?.discountValue ?? 0);

    if (!discountValue || Number.isNaN(discountValue)) {
      return 0;
    }

    if (discountMethod === "flat") {
      return Math.min(discountValue, amount);
    }

    if (discountMethod === "percentage" || discountMethod === "percent") {
      return Math.min((amount * discountValue) / 100, amount);
    }

    return 0;
  };

  const getCountryDiscountDetail = (eventData = selectedEvent) => {
    const countryDiscount = getActiveDiscountByType("country", eventData);
    const details = Array.isArray(countryDiscount?.details) ? countryDiscount.details : [];

    if (!details?.length) {
      return null;
    }

    const normalizeCountryCandidates = (vals) => {
      const normalized = new Set();

      vals
        .filter((val) => val !== undefined && val !== null && `${val}` !== "")
        .forEach((val) => {
          const raw = `${val}`.trim();
          if (!raw) {
            return;
          }

          normalized.add(raw.toLowerCase());

          if (/^\d+$/.test(raw)) {
            normalized.add(`${Number(raw)}`);
          }
        });

      return normalized;
    };

    const userCountryCandidates = normalizeCountryCandidates([
      user?.user?.country_id,
      user?.user?.countryId,
      user?.user?.country,
      user?.user?.country_name,
      user?.user?.countryName,
      user?.user?.country_code,
      user?.user?.countryCode,
      user?.user?.default_country_code,
      user?.user?.defaultCountryCode,
    ]);

    const matchedDetail = details.find((detail) => {
      const detailCandidates = normalizeCountryCandidates([
        detail?.reference_id,
        detail?.referenceId,
        detail?.country_id,
        detail?.countryId,
        detail?.country,
        detail?.country_name,
        detail?.countryName,
        detail?.country_code,
        detail?.countryCode,
        detail?.name,
        detail?.code,
      ]);

      return Array.from(detailCandidates).some((val) => userCountryCandidates.has(val));
    });

    if (matchedDetail) {
      return matchedDetail;
    }

    // Apply single-detail fallback only when it is a global discount rule
    // (no country/reference fields present in the detail object).
    if (details?.length === 1) {
      const onlyDetail = details[0] || {};
      const hasCountryReference = [
        onlyDetail?.reference_id,
        onlyDetail?.referenceId,
        onlyDetail?.country_id,
        onlyDetail?.countryId,
        onlyDetail?.country,
        onlyDetail?.country_name,
        onlyDetail?.countryName,
        onlyDetail?.country_code,
        onlyDetail?.countryCode,
        onlyDetail?.code,
      ].some((val) => val !== undefined && val !== null && `${val}`.trim() !== "");

      return hasCountryReference ? null : onlyDetail;
    }

    return null;
  };

  const getCountryDiscountMeta = (baseAmount, eventData = selectedEvent) => {
    const discountDetail = getCountryDiscountDetail(eventData);
    const discountAmount = getDiscountAmount(baseAmount, discountDetail);
    const label =
      discountDetail?.country_name ||
      discountDetail?.countryName ||
      discountDetail?.country ||
      user?.user?.country_name ||
      user?.user?.countryName ||
      user?.user?.country ||
      "";

    return {
      discountAmount,
      label,
    };
  };

  const setEnrollData = (data, eventData) => {
    const activeEvent = eventData || selectedEvent;

    const normalizedDivisions =
      data?.division?.map((division = {}) => {
        const effectiveBaseEntryFee = Number((division?.lateFee || division?.entryFee) || 0);
        const effectiveDiscount = Number(division?.divisionDiscountAmount || 0);
        const effectiveFinalEntryFee = Math.max(effectiveBaseEntryFee - effectiveDiscount, 0);

        return {
          ...division,
          baseEntryFee: effectiveBaseEntryFee,
          finalEntryFee: effectiveFinalEntryFee,
        };
      }) || [];

    console.log("selectedEvent => ", selectedEvent)
    console.log("setEnrollData => ", data, eventData)
    const dvdFee = eventVideoFee(data?.["doWantDvd"], eventData);

    const netDivisionsBeforeCountryDiscount =
      normalizedDivisions?.reduce(
        (a, division = {}) => {
          const photoFee = Number(division?.photoFee || 0);
          return photoFee + Number(division?.finalEntryFee || 0) + a;
        },
        0
      ) || 0;

    const additionalServicesFee =
      data?.additionalServiceId?.reduce(
        (a, { serviceFeeYes = 0, serviceFeeNo = 0 }) => {
          return serviceFeeYes + serviceFeeNo + a;
        },
        0
      ) || 0;

    const divisionDiscountAmount =
      normalizedDivisions?.reduce((a, { divisionDiscountAmount = 0 }) => {
        return a + Number(divisionDiscountAmount || 0);
      }, 0) || 0;

    const grossDivisionsTotalFee =
      Number(netDivisionsBeforeCountryDiscount || 0) +
      Number(divisionDiscountAmount || 0);

    const { discountAmount: countryDiscountAmount, label: countryDiscountLabel } =
      getCountryDiscountMeta(netDivisionsBeforeCountryDiscount, activeEvent);

    const netDivisionsTotalFee = Math.max(
      Number(netDivisionsBeforeCountryDiscount || 0) - Number(countryDiscountAmount || 0),
      0
    );

    setUpdatedEnrollData({
      ...data,
      division: normalizedDivisions,
      amount: dvdFee + additionalServicesFee + netDivisionsTotalFee,
      divisionsTotalFee: grossDivisionsTotalFee,
      netDivisionsTotalFee,
      divisionDiscountAmount,
      countryDiscountAmount,
      countryDiscountLabel,
      eventId: activeEvent?.id || data?.eventId,

      userId: props?.userId,
      enrollId: props?.enrolId
    });
  };

  const hideConfirmation = () => {
    setConfirmation({ ...confirmation, open: false });
  };

  const getDivisionDiscountedPrice = (divisionId, basePrice) => {
    const actualPrice = Number(basePrice || 0);

    const eventDiscounts = Array.isArray(selectedEvent?.discounts)
      ? selectedEvent?.discounts
      : [selectedEvent?.discounts].filter(Boolean);

    const activeDivisionDiscount = eventDiscounts?.find(
      ({ discount_type, discountType, is_active, isActive }) => {
        const discountTypeValue = `${discount_type || discountType || ""}`.toLowerCase();
        const isActiveValue = is_active ?? isActive;
        return (
          discountTypeValue === "division" &&
          (isActiveValue === 1 || isActiveValue === "1" || isActiveValue === true)
        );
      }
    );

    const discountDetail = activeDivisionDiscount?.details?.find(
      ({ reference_id, referenceId }) =>
        `${reference_id ?? referenceId}` === `${divisionId}`
    );

    if (!discountDetail) {
      return actualPrice;
    }

    const discountMethod = `${discountDetail?.discount_method || discountDetail?.discountMethod || ""}`.toLowerCase();
    const discountValue = Number(discountDetail?.discount_value ?? discountDetail?.discountValue ?? 0);

    if (!discountValue || Number.isNaN(discountValue)) {
      return actualPrice;
    }

    if (discountMethod === "flat") {
      return Math.max(actualPrice - discountValue, 0);
    }

    if (discountMethod === "percentage" || discountMethod === "percent") {
      return Math.max(actualPrice - (actualPrice * discountValue) / 100, 0);
    }

    return actualPrice;
  };


  const onEventSelect = (event) => {
    if (!selectedEvent) {
      return setSelectedEvent(event);
    }

    if (selectedEvent?.id === event?.id) {
      return;
    }
    setConfirmation({
      title: strings.eventChange,
      subTitle: strings.eventChangeSubTitle,
      yesText: "Yes",
      noText: "No",
      open: true,
      noClick: () => hideConfirmation(),
      yesClick: () => {
        const index = events.findIndex(({ id }) => id === selectedEvent?.id);

        const eventOld = events[index];
        eventOld.divisions = eventOld.divisions?.map((ev) => ({ ...ev, selected: false }))
        events[index] = { ...eventOld }
        console.log("index => ", index, eventOld)
        setEvents([...events])

        setSelectedEvent(event);
        hideConfirmation();
        setEnrollData(null);
      },
    });
  };

  const withdrawDivision = (selectedId) => {
    setConfirmation({
      title: strings.eventDivisionWithdraw,
      subTitle: strings.eventChangeSubTitle,
      yesText: "Yes",
      noText: "No",
      open: true,
      noClick: () => hideConfirmation(),
      yesClick: () => {
        hideConfirmation();
        const newData = selectedEvent;
        const findIndex = newData?.divisions?.findIndex(
          ({ id }) => id === selectedId
        );
        newData.divisions[findIndex].selected = undefined;
        setSelectedEvent({ ...newData });

        const index = enrollData?.division?.findIndex(
          ({ eventDivisionId: id }) => id === selectedId
        );
        if (index >= 0) {
          enrollData.division.splice(index, 1);

          const hasEventProDivisionEntryFee =
            Number(selectedEvent?.proDivisionEntryFee || 0) > 0;

          let nonProDivisionCount = 0;
          const recalculatedDivisions = enrollData.division?.map((divisionData) => {
            const divisionMeta = selectedEvent?.divisions?.find(
              ({ id }) => id === divisionData?.eventDivisionId
            );
            const isProDivision =
              (divisionMeta?.isProFee || divisionMeta?.isPro) === "yes";
            const hasProDivisionEntryFee =
              Number(divisionMeta?.proDivisionEntryFee || 0) > 0;
            const isFixedProDivisionFee =
              isProUser &&
              isProDivision &&
              (hasProDivisionEntryFee || hasEventProDivisionEntryFee);

            if (isFixedProDivisionFee) {
              const proBaseFee = Number(
                hasProDivisionEntryFee
                  ? divisionMeta?.proDivisionEntryFee
                  : selectedEvent?.proDivisionEntryFee || 0
              );

              const discountedFee = getDivisionDiscountedPrice(
                divisionData?.eventDivisionId,
                proBaseFee
              );

              return {
                ...divisionData,
                baseEntryFee: proBaseFee,
                divisionDiscountAmount: Math.max(
                  Number(proBaseFee || 0) - Number(discountedFee || 0),
                  0
                ),
                entryFee: proBaseFee,
                lateFee: 0,
                finalEntryFee: discountedFee,
              };
            }

            const isFirstNonProDivision = nonProDivisionCount === 0;
            const baseFee = isFirstNonProDivision
              ? selectedEvent?.divisionEntryFee
              : selectedEvent?.additionalDivisionEntryFee;

            let updatedLateFee = 0;
            if (isLateFeeAppliedOnEditEvent && editId) {
              updatedLateFee = isFirstNonProDivision
                ? selectedEvent?.firstDivisionSurcharge || 0
                : selectedEvent?.additionalDivisionSurcharge || 0;
            } else if (!editId) {
              updatedLateFee = isFirstNonProDivision
                ? lateFee?.firstDivisionSurcharge || 0
                : lateFee?.additionalDivisionSurcharge || 0;
            }

            nonProDivisionCount += 1;

            const normalizedEntryFee = Number(baseFee || 0);
            const normalizedLateFee = Number(updatedLateFee || 0);
            const baseEntryFee = Number((normalizedLateFee || normalizedEntryFee) || 0);
            const discountedFee = getDivisionDiscountedPrice(
              divisionData?.eventDivisionId,
              baseEntryFee
            );

            return {
              ...divisionData,
              baseEntryFee,
              divisionDiscountAmount: Math.max(
                Number(baseEntryFee || 0) - Number(discountedFee || 0),
                0
              ),
              entryFee: normalizedEntryFee,
              lateFee: normalizedLateFee,
              finalEntryFee: discountedFee,
            };
          }) || [];

          setEnrollData({ ...enrollData, division: recalculatedDivisions });
        }
      },
    });
  };

  const updateEventWithType = (eves, freeEventIds = []) => {
    setEvents(
      eves
        ?.map((evt) => {
          if (
            freeEventIds?.includes(evt?.id) ||
            evt?.isFree ||
            evt?.event_type === "free"
          ) {
            evt.isFree = true;
          } else if (evt.isTfxEvent === "yes") {
            evt.isTransformation = true;
          } else if (evt?.promoter?.[0]?.country == user?.user?.country_id) {
            evt.isDomestic = true;
          } else {
            evt.isInternational = true;
          }

          return evt;
        })
        .filter(
          (evt) => ( //evt?.divisions?.length &&
            (evt?.allowOnlyPro == 'yes') ? (user?.user?.professional == 'yes' || user?.user?.pro_qualified == 'yes') : true
          )
        )
    );
  };

  const getData = () => {
    if (!user) return
    setLoading(true);
    Promise.all([
      API.get({ route: getAPIUrl(endpoints.EVENT) }),
      /** free events do not require a membership, they are fetched separately
       * so they can be listed (and enrolled into) on their own */
      API.get({ route: `${getAPIUrl(endpoints.EVENT)}?event_type=free` }).catch(
        () => ({ status: true, result: [] })
      ),
    ])
      .then(([data, freeData]) => {
        if (data?.status) {
          updateEventWithType(
            data?.result,
            freeData?.result?.map(({ id }) => id) || []
          );
        } else {
          showToast({
            text: data?.message,
            type: toastType.ERROR,
          });
        }
      })
      .catch((data) => {
        showToast({
          text: errorToString(data?.response),
          type: toastType.ERROR,
        });
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    setCurrency(`${selectedEvent?.eventCurrency?.sign || ""}`);

    if (selectedEvent?.lateEntryFees !== "yes" || !selectedEvent?.lateFeeStartDate) {
      setLateFee({
        firstDivisionSurcharge: 0,
        additionalDivisionSurcharge: 0,
      });
    } else {
      const current = moment.utc();
      const lateDate = moment.utc(
        selectedEvent?.lateFeeStartDate,
        "YYYY-MM-DD HH:mm:ss",
        true
      );

      if (lateDate.isValid() && current.diff(lateDate, 'minutes') >= 0) {
        setLateFee({
          firstDivisionSurcharge: selectedEvent?.firstDivisionSurcharge,
          additionalDivisionSurcharge: selectedEvent?.additionalDivisionSurcharge,
        });
      } else {
        setLateFee({
          firstDivisionSurcharge: 0,
          additionalDivisionSurcharge: 0,
        });
      }
    }
  }, [selectedEvent?.id]);

  const enrollEvent = () => {
    userCheck(() => {
      setLoading(true);

      API.post({ route: getAPIUrl(endpoints.EVENT_ENROL), params: enrollData })
        .then((data) => {
          if (props?.updateData) {
            props?.updateData?.()
            showToast({
              text: 'Division/s Updated Successfully!',
            });
          } else {
            navigate(
              // `/enter-event-success/${data?.data?.data}${selectedEvent?.entrySuccessImage ? `?image=${encodeURI(selectedEvent?.entrySuccessImage)}` : ''}`
              `/enter-event-success/${data?.data?.data}/${selectedEvent?.id}`
            );
          }
        })
        .catch((data) => {
          showToast({
            text: errorToString(data?.response),
            type: toastType.ERROR,
          });
        })
        .finally(() => setLoading(false));
    });
  };

  return (
    <EnterEventContext.Provider
      value={{
        events,
        onEventSelect,

        selectedEvent,
        setSelectedEvent,

        enrollData,
        setEnrollData,
        enrollEvent,

        withdrawDivision,
        currency,

        agreeRef,
        termsError,
        setTermsError,
        termsChecked,
        setTermChecked,
        setConfirmation,
        eventVideoFee,
        lateFee,
        editId,
        isProUser,

        isLateFeeAppliedOnEditEvent,
      }}
    >
      {props.children}
      <ConfirmationNoBtn {...confirmation} />
    </EnterEventContext.Provider>
  );
};

export const useEnterEvent = () => useContext(EnterEventContext);
